export enum AnswerType {
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    E = "E"
}